<template>
  <div class="container-fluid">

    <div class="container-fluid" >
      <div class="d-flex justify-content-center">
        <q-linear-progress v-if="!chartLoaded" color="primary" indeterminate />
      </div>

      <div class="graph-container">
          <div class="graph-chart large-graph">
            <q-btn-toggle v-if="chartLoaded" v-model="selectedWellbeingGraph" style="margin: auto"         no-caps
              rounded
              unelevated
              toggle-color="primary"
              color="white"
              text-color="primary"
              :options="wellbeingOptions">
            </q-btn-toggle>
            <Bar style="height: 100%" v-if="chartLoaded" :chartData="this.clientWellbeingData"
              :chartOptions="this.clientIssuesChartOptions">
            </Bar>

          </div>

        <div class="graph-chart large-graph">
          <Bar style="height: 100%" v-if="chartLoaded" :chartData="this.clientGoalsSetData"
            :chartOptions="this.clientGoalsSetChartOptions">
          </Bar>
        </div>

        <div class="graph-chart large-graph">
          <Bar style="height: 100%" v-if="chartLoaded" :chartData="this.clientGoalsAchievedData"
            :chartOptions="this.clientGoalsAchievedChartOptions">
          </Bar>
        </div>

        <div class="graph-chart large-graph">
          <Bar style="height: 100%" v-if="chartLoaded" :chartData="this.clientGoalsPartiallyAchievedData"
            :chartOptions="this.clientGoalsPartiallyAchievedChartOptions">
          </Bar>
        </div>
      </div>
    </div>
    <q-inner-loading :showing="visible" label="Please wait..." label-class="text-teal" label-style="font-size: 1.1em" />
    <WellbingBreakdownComponent v-if="showBreakdownModal" :label="label" :query="query" :type="selectedWellbeingGraph"
      @close="showBreakdownModal = false" />
  </div>
</template>
  
<script>


import api from "../../services/api/api";
import notify from '@/services/util/notify';

import Bar from "../ChartComponents/Bar.vue";
import { retBarOptions, retBarOptionsIssues } from "../DataComponents/chartOptions";

import WellbingBreakdownComponent from "./IndividualPopupComponents/WellbingBreakdownComponent.vue";

export default ({
  name: 'ClientImpact',
  components: { Bar, WellbingBreakdownComponent },
  props: ['query'],

  data() {
    return {
      chartLoaded: false,

      clientWellbeingData: null,
      clientGoalsSetData: null,
      clientGoalsAchievedData: null,

      clientIssuesChartOptions: null,
      clientGoalsSetChartOptions: retBarOptions(true, "Goals Set", "y", "# of People", "", 10),
      clientGoalsAchievedChartOptions: retBarOptions(true, "Goals Achieved", "y", "# of People", "", 10),
      clientGoalsPartiallyAchievedChartOptions: retBarOptions(true, "Goals Partially Achieved", "y", "# of People", "", 10),

      visible: false,

      label: null,
      showBreakdownModal: false,
      selectedWellbeingGraph: 'significant', // Default to significant
      wellbeingOptions: [
        {label: 'Most Significant Pou', value: 'significant'}, 
        {label: 'All Relevant Pou', value: 'relevant'},
      ],

      clientWellbeingSignificantData: [],
      clientWellbeingRelevantData: []
    }
  },

  created() {
    this.onIntialize();

    this.clientIssuesChartOptions = retBarOptionsIssues({
      onClickHandler: this.handleClickEvent,
      legend: false,
      title: "Reasons For Referral",
      indexAxis: "y",
      xAxis: "# of People",
      barThickness: 25
    });
  },

  watch: {
    selectedWellbeingGraph() {
      this.toggleWellbeingGraph(this.selectedWellbeingGraph);
    }
  },

  methods: {

  /**
   * When the client issues chart is clicked, return the breakdown of the clicked bar.
   * @param event 
   * @param elements 
   * @param chart 
   */
  handleClickEvent(event, elements, chart) {
    if (!elements.length) return;

    const { index } = elements[0];
    this.label = chart.data.labels[index];

    this.showBreakdownModal = true;
  },

  /**
   * Set all the required chart data and chart options.
   */
  onIntialize() {
    // Fetch all client data from backend. Returns list of data once all requests have completed
    const fetchData = (query) => Promise.all([
      api.wellbeing.wellbeingChart('significant', query),
      api.wellbeing.wellbeingChart('relevant', query),

      api.clientGraph.clientGoals("date_set", query),
      api.clientGraph.clientGoals("date_achieved", query),
      api.clientGraph.clientGoals("date_partially_achieved", query),
    ])

    fetchData(this.query).then((values) => {
      this.clientWellbeingData = values[0]['data'] ?? []

      this.clientWellbeingSignificantData = values[0]['data'] ?? []
      this.clientWellbeingRelevantData = values[1]['data'] ?? []

      this.clientGoalsSetData = values[2]['data']
      this.clientGoalsAchievedData = values[3]['data']
      this.clientGoalsPartiallyAchievedData = values[4]['data']

      this.calculateBarWidth(this.clientGoalsSetData.labels.length)

    }).catch(() => {
      notify.error("Error retrieving client impact data", 'top');
    }).finally(() => {
      this.chartLoaded = true
    })
  },

  calculateBarWidth(numberOfLabels) {
    // Define a base width and the minimum width for the bars
    const baseWidth = 45;
    const minWidth = 10;

    // Define the maximum number of labels before the width should reach the minimum
    const maxLabels = 15;

    // Calculate the width based on the number of labels
    const width = Math.max(minWidth, baseWidth - (numberOfLabels - 5) * (baseWidth - minWidth) / (maxLabels - 5));

    this.clientGoalsSetChartOptions = retBarOptions(true, "Goals Set", "y", "# of People", "", width)
    this.clientGoalsAchievedChartOptions = retBarOptions(true, "Goals Achieved", "y", "# of People", "", width)
    this.clientGoalsPartiallyAchievedChartOptions = retBarOptions(true, "Goals Partially Achieved", "y", "# of People", "", width)
  },

  toggleWellbeingGraph(graph) {
    if (graph == 'significant') {
      this.clientWellbeingData = this.clientWellbeingSignificantData;
    } else {
      this.clientWellbeingData = this.clientWellbeingRelevantData;
    }
  }
}
  })



</script>
  
<style scoped>
@import '../../assets/styles/clientDemographics.css';
</style>
